import React, { useState, useEffect } from "react";
import * as AzureService from "../../api/ticketsApiAzure";
import TimelineAdo from "./TimelineAdo";
import ToolBarAdo from "./Toolbar/ToolBar_ADO";
import * as tConst from "../../common/Constants";
import * as TimelineStore from "../../utils/timelineStore";
import LoginAdo from "./LoginAdo2";
import prepareTicket, { prepareTickets } from "./data/prepareTicket";
import moment from "moment";
import findQuarterStart from "./data/findQuarterStart";


//https://medium.com/weekly-webtips/implementing-a-rest-api-with-react-hooks-using-patterns-2ea1476e2a05


const TimelinePageAdo = ({ auth, updateAuth }) => {
    const [projects, setProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState(TimelineStore.getSelectedProject()); // "Test for oyvindh"
    const [items, setItems] = useState([]);
    const [itemIds, setItemsIds] = useState([]);
    const [openOnClickStatus, setOpenOnClickStatus] = useState(TimelineStore.getOnClickStatus());
    const [isLoaded, setIsLoaded] = useState(false);
    const [itemQuery, setItemQuery] = useState({ query: "Select [System.Id] , [System.Title], [System.State], [Custom.EndIteration], [Custom.StartIteration] From WorkItems Where [Custom.EndIteration] <> '' AND [State] <> 'Closed' and [System.TeamProject] = @project order by [Custom.PlanningPriority] asc, [Custom.StartIteration] asc, [System.CreatedDate] asc" });
    const [refresh, setRefresh] = useState();
    const [showChartMenu, setShowChartMenu] = useState(false);
    const [viewId, setViewId] = useState(TimelineStore.getSelectedViewId());
    const [assigneeList, setAssigneeList] = useState([]);
    const [assigneeId, setAssigneeId] = useState(tConst.ADO_ASSIGNED_ALL);
    const [initiativeList, setInitiativeList] = useState([]);
    const [selectedInitiative, setSelectedInitiative] = useState(tConst.ADO_INITIATIVE_ALL);
    const [teamsId, setTeamsId] = useState(tConst.VIEW_ALL_TEAMS);
    const [quarterFilter, setQuarterFilter] = useState();
    const [chartHeight, setChartHeight] = useState(TimelineStore.getChartHeight());
    const [filterMinPlanningPri, setFilterMinPlanningPri] = useState(Number.MIN_SAFE_INTEGER);
    const [filterMaxPlanningPri, setFilterMaxPlanningPri] = useState(Number.MAX_SAFE_INTEGER);

    const [hideProjects, setHideProjects] = useState(TimelineStore.getHideProjects());
    //#region useEffects


    const handleChartHeightChange = (newHeight) => {
        setChartHeight(newHeight);
        TimelineStore.setChartHeight(newHeight);
    };
    //#region Project
    useEffect(() => {
        setIsLoaded(false);
        if (auth && auth.un !== "" && auth.pw !== "") {

            AzureService.getProjects(auth).then(async (response) => {
                setProjects(response.value.map(project => { return { label: project.name, id: "" + project.id, name: project.name, value: project.id } }));
                setIsLoaded(true);
            }).catch((error) => {
                console.log("Error in getProjects: " + error);
                updateAuth({ un: "", pw: "" })
            });
        }
    }, [auth, updateAuth]);
    //#endregion Project

    //#region  WorkItems
    useEffect(() => {
        setIsLoaded(false);

        const _selectedProject = projects ? projects.filter((filt) => {
            return filt.value === selectedProject
        }) : null;

        const _selectedProjectName = _selectedProject && _selectedProject[0] ? _selectedProject[0].name : "";
        console.log("_selectedProjectName: " + _selectedProjectName);

        setItems([]);

        if (auth && auth.un !== "" && auth.pw !== "") {


            let _itemQuery = { ...itemQuery };

            if (quarterFilter) {
                
                const  _startOfCalendarQuarterForSelectedFilter = moment(quarterFilter.toDate()).startOf('quarter').toDate();
                const  _endOfCalendarQuarterForSelectedFilter = moment(quarterFilter.toDate()).endOf('quarter').toDate();
                
                const startofTimelineQuarter = findQuarterStart(_startOfCalendarQuarterForSelectedFilter);
                const nextTimelineQuarterStart = findQuarterStart(_endOfCalendarQuarterForSelectedFilter);
                
                const startFilterQuarter = startofTimelineQuarter.toISOString().substring(0, 10);
                const endFilterQuarter = nextTimelineQuarterStart.toISOString().substring(0, 10);
                
                // Date filter: when the ticket starts before end of quarter and ends after start of quarter:
                const dateFilter = " AND "+  tConst.AF_START_ITERATION+" < \"" + endFilterQuarter +"\" AND " + tConst.AF_END_ITERATION+" >\"" + startFilterQuarter +"\" order by "

                _itemQuery.query = itemQuery.query.replace("order by", dateFilter);

            }   
            if (selectedInitiative !== tConst.ADO_INITIATIVE_ALL) {

                // Will include initiative in the query
                _itemQuery.query = itemQuery.query.replace("order by", " AND [Custom.Initiative] = '" + selectedInitiative + "' order by ");
            }

            AzureService.getItemsList(auth, _itemQuery, _selectedProjectName).then(
                async (response) => {
                    let ids = response.workItems.map((item) => item.id)
                    setItemsIds(ids);
                });
        }
    }, [auth, itemQuery, selectedProject, refresh, projects, selectedInitiative, quarterFilter]);


    useEffect(() => {

        if (auth && auth.un !== "" && auth.pw !== "" && itemIds.length > 0) {
            let itemIdsWithChildrenCount = itemIds.length

            if (selectedInitiative !== tConst.ADO_INITIATIVE_ALL) {
                itemIds.forEach((item) => {

                    AzureService.getItem(auth, item).then((response) => {
                        const _title = response.fields[tConst.AF_TITLE];

                        const _item = prepareTicket(response, _title, "#FAA0A0")
                        _item && _item.relations && _item.relations.forEach((rel) => {
                            if (rel.rel === "System.LinkTypes.Dependency-Reverse") {

                                const child = rel.url.split("/");
                                _item.Color = "#90EE90";
                                AzureService.getItem(auth, child[child.length - 1]).then((response) => {
                                    itemIdsWithChildrenCount++;
                                    const _item = prepareTicket(response, _title,"" , 1000000 )
                                    items.push(_item);

                                    if (items.length === itemIdsWithChildrenCount) {
                                        prepareTickets(items, setAssigneeList, () => { console.log("Do not update initiative list") });
                                        setIsLoaded(true);
                                    }

                                })
                            }
                        })

                        items.push(_item);


                        if (items.length === itemIdsWithChildrenCount) {
                            prepareTickets(items, setAssigneeList, () => { console.log("Do not update initiative list") });
                            setIsLoaded(true);
                        }
                    })
                })
            }
            else if (selectedProject === "RnD Planning" || selectedProject === "56a5763c-99be-4053-929f-10e7fd0350b2") {
                // Special case for RnD Planning - where we want to show all items with children
                itemIds.forEach((item) => {

                    AzureService.getItem(auth, item).then((response) => {
                        const _Initiative = response.fields[tConst.AF_INITIATIV]
                        if (item === 24854) {
                            console.log("Item 24854: " + JSON.stringify(response, null, 4));
                        }

                        const _item = prepareTicket(response, _Initiative, "")
                        _item && _item.relations && _item.relations.forEach((rel) => {
                            if (rel.rel === "System.LinkTypes.Hierarchy-Forward") {

                                const child = rel.url.split("/");
                                //                                _item.Color = "#90EE90";
                                AzureService.getItem(auth, child[child.length - 1]).then((response) => {
                                    itemIdsWithChildrenCount++;
                                    const _item = prepareTicket(response, _Initiative,"" , 1000000 )
                                    if (!items.some(existingItem => existingItem.id === _item.id)) {
                                        items.push(_item);
                                    }
                                    else {
                                        itemIdsWithChildrenCount--;
                                    }
                                    //items.push(_item);

                                    if (items.length === itemIdsWithChildrenCount) {
                                        prepareTickets(items, setAssigneeList, () => { console.log("Do not update initiative list") });
                                        setIsLoaded(true);
                                    }

                                })
                            }
                        })

                        items.push(_item);


                        if (items.length === itemIdsWithChildrenCount) {
                            prepareTickets(items, setAssigneeList, () => { console.log("Do not update initiative list") });
                            setIsLoaded(true);
                        }
                    })
                })
            }
            else {


                //#region Batch fetch
                let first = 0;
                let batchSize = 200;
                let pageIds = null;
                while (first < itemIds.length) {

                    pageIds = itemIds.slice(first, first + batchSize);
                    AzureService.getItems(auth, pageIds).then(
                        async (response) => {
                            const tempItems = response.value.map(item => {
                                return prepareTicket(item);
                            })

                            const _items = items;
                            _items.push(...tempItems)
                            setItems(_items);


                            if (items.length === itemIds.length) {
                                prepareTickets(items, setAssigneeList, setInitiativeList);
                                setIsLoaded(true);
                            }
                        }
                    );
                    first = first + batchSize;
                }
                //#endregion Batch fetch
            }


        }
        else {
            setIsLoaded(true);
            setItems([]);
        }
        // Will not trigger this on items - it is just used to write it
    }, [auth, itemIds]);
    //#endregion WorkItems

    //#endregion useEffects

    if (auth?.un === "" && auth.pw === "") {
        // Show Login
        return (
            <>
                <div>Missing Username and password</div>
                <LoginAdo updateAuth={updateAuth}></LoginAdo>
            </>
        )
    }
    else if (isLoaded) {
        const showTeamFilter = (selectedProject === "56a5763c-99be-4053-929f-10e7fd0350b2");
        return (
            <>
                <ToolBarAdo
                    projects={projects.filter((item) => { return (hideProjects.indexOf(item.id) === -1) }).sort((a, b) => a.label > b.label ? 1 : -1)}
                    selectedProject={selectedProject}
                    projectOnChange={(event) => {
                        TimelineStore.setSelectedProject(event.value);
                        setTeamsId(tConst.VIEW_ALL_TEAMS)
                        setSelectedInitiative(tConst.ADO_INITIATIVE_ALL);
                        setQuarterFilter(null)
                        setSelectedProject(event.value);
                        const _itemQuery = tConst.AZURE_Q1 + (event?.value !== "" ? tConst.AZURE_Q_PROJECT + " '" + event.label + "' " : "") + tConst.AZURE_Q_ORDER_BY;
                        console.log("_itemQuery: " + _itemQuery);
                        setItemQuery({ query: _itemQuery });
                    }}
                    openOnClickStatus={openOnClickStatus}
                    setOpenOnClickStatus={(value) => {
                        TimelineStore.setOnClickStatus(value);
                        setOpenOnClickStatus(value);
                    }}
                    onRefreshClick={() => setRefresh(Date.now())}
                    onLogout={() => { updateAuth({ un: "", pw: "" }) }}
                    viewId={viewId ? viewId : tConst.VIEW_ALL_PLANNED}
                    viewOnChange={(event) => {
                        //Set to persistant store
                        TimelineStore.setSelectedViewId(event.value);
                        setViewId(event.value)
                    }}
                    assigneeList={[{ label: tConst.ADO_ASSIGNED_ALL, value: tConst.ADO_ASSIGNED_ALL }, ...assigneeList]}
                    assigneeId={assigneeId}
                    assigneeOnChange={(event) => {
                        setAssigneeId(event.value)
                        setTeamsId(tConst.VIEW_ALL_TEAMS)

                    }}
                    initiativeList={[{ label: tConst.ADO_INITIATIVE_ALL, value: tConst.ADO_INITIATIVE_ALL }, { label: tConst.ADO_INITIATIVE_BLANK, value: tConst.ADO_INITIATIVE_BLANK }, ...initiativeList]}
                    selectedInitiative={selectedInitiative}
                    initiaitveOnChange={(event) => {
                        if (event.value === tConst.ADO_INITIATIVE_ALL) {
                            setSelectedInitiative(tConst.ADO_INITIATIVE_ALL);
                        }
                        else {
                            setSelectedInitiative(event.value)
                        }
                    }}

                    teamsId={teamsId}
                    teamsOnChange={(event) => {
                        setTeamsId(event.value)
                        setAssigneeId(tConst.ADO_ASSIGNED_ALL)
                    }}
                    showTeamsFilter={showTeamFilter}
                    quarterFilter={quarterFilter}
                    setQuarterFilter={setQuarterFilter}


                    onHideProject={(projectId) => {
                        if (hideProjects.indexOf(projectId) === -1) {
                            const b = [...hideProjects, projectId];
                            TimelineStore.setHideProjects(b);   

                            setHideProjects(b);

                        }

                    }}
                    chartHeight={chartHeight}
                    onHandleChartHeightChange={handleChartHeightChange}
                    filterMinPlanningPri={filterMinPlanningPri}
                    filterMaxPlanningPri={filterMaxPlanningPri}
                    setFilterMinPlanningPri={setFilterMinPlanningPri}
                    setFilterMaxPlanningPri={setFilterMaxPlanningPri}
                />
                <TimelineAdo
                    items={items}
                    viewId={viewId}
                    assigneeFilterName={assigneeId}
                    selectedInitiative={selectedInitiative}
                    teamsFilterName={teamsId}
                    openOnClickStatus={openOnClickStatus}
                    showChartMenu={showChartMenu}
                    chartHeight = {chartHeight} 
                    setChartHeight={setChartHeight}
                    filterMinPlanningPri={filterMinPlanningPri}
                    filterMaxPlanningPri={filterMaxPlanningPri}
                    setFilterMinPlanningPri={setFilterMinPlanningPri}
                    setFilterMaxPlanningPri={setFilterMaxPlanningPri}

                    auth={auth}
                    //  props.project
                    project={selectedProject}
                    quarterFilter={quarterFilter}
                    setShowChartMenu={setShowChartMenu}
                    onMoveAndExtendIteration={(selectedTicket, MoveNumberOfDays, extendNumberOfDays = 0) => {
                        AzureService.moveAndExtendTicketIteration(auth, selectedTicket, MoveNumberOfDays, extendNumberOfDays).then(() => {
                            setShowChartMenu(false);
                            setRefresh(Date.now());
                        });
                    }}
                    // onExtendIteration={(selectedTicket, numberOfDays) => {
                    //     console.log("onExtendIteration clicked ticketID: "+ selectedTicket.id + ", numberOfDays: "+ numberOfDays )
                    //     AzureService.moveAndExtendTicketIteration(auth,selectedTicket,0, numberOfDays).then(() => {
                    //         setShowChartMenu(false);
                    //         setRefresh(Date.now());
                    //     });
                    // }}
                    Search={(ticketId) => {
                        console.log("User clicked search: " + ticketId);
                        return AzureService.getItem(auth, ticketId);
                    }}
                    onAddTicketToSprint={
                        (ticketId, StartDate, EndDate) => {
                            return AzureService.setIteration(auth, ticketId, StartDate, EndDate);
                        }
                    }
                    onUpdateTicket={(ticketId, data) => {
                        return AzureService.onUpdateTicket(auth, ticketId, data);
                    }}

                    onSetRefresh={() => { setRefresh(Date.now()) }}
                /*
                                    onAddChildrenToTimeline={(selectedTicket) =>{
                                        console.log("onAddChildrenToTimeline: "+JSON.stringify(selectedTicket, null, 4));
                                        AzureService.AddChildrenToTimeline(auth,selectedTicket).then(() => {
                                            setShowChartMenu(false);
                                            setRefresh(Date.now());
                                        });
                            
                                    }}
                                    onPlanningToChildren={(selectedTicket)=>{console.log("onPlanningToChildren: "+JSON.stringify(selectedTicket, null, 4))}}
                                    */

                />


            </>
        );
    }
    else {
        return (
            <div>Loading...</div>
        )
    }

};

function getChildren(auth, item, items) {
    const children = [];
    if (item.relations && item.relations.length > 0) {
        item.relations.forEach((rel) => {
            if (rel.rel === "System.LinkTypes.Dependency") {
                const child = rel.url.split("/");
                const _child = items.find((item) => item.id === child[child.length - 1]);
                if (_child) {
                    AzureService.getItem(auth, child[child.length - 1]).then((response) => {
                        const fetchedChild = prepareTicket(response);
                        if (fetchedChild) {
                            children.push(fetchedChild);
                        }
                    });
                }
            }
        });
    }
    return children;
}

export default TimelinePageAdo;
